module.exports = __webpack_public_path__ + "img/schedule.516d0842.svg";